import axios from "axios";
import config from "../config";

const API_URL = config.API_URL;

// This service is loaded before the Redux store by ModuleAccessGuard. Read
// authentication from the calling thunk, never by importing the store (including
// indirectly through auth-header), so the permissions reducer can initialize.
const requestHeaders = (auth, contentType = "application/json") =>
  auth.token ? { Authorization: `Bearer ${auth.token}`, "Content-Type": contentType } : {};

const moduleview = (values, thunkAPI) => {
  const auth = thunkAPI.getState().auth;
  const auth_key = auth.user.auth_key;
  const action = `afterlogin/usermodule/view`;
  const data = {
    auth_key: auth_key,
    action: action,
    salon_permission_field: 0,
    type: "Menu",
  };
  return axios.post(API_URL + action, data, { headers: requestHeaders(auth) });
};

const accessview = (values, thunkAPI) => {
  const auth = thunkAPI.getState().auth;
  const auth_key = auth.user.auth_key;
  // const auth_role_id = auth.user.role_id;
  // const role_id = values && values.type && values.type === "staff_access" && auth_role_id === 4 ? 5 : auth_role_id;
  // const salon_id = auth.user.salon_id;
  const action = `afterlogin/usermodule/view`;
  
  const data = {
    auth_key: auth_key,
    action: action,
    apicall:'accessview'
    // accesstype: values.type,
  };
  return axios.post(API_URL + action, data, { headers: requestHeaders(auth) });
};

const update = (values, thunkAPI) => {
  const auth = thunkAPI.getState().auth;
  const auth_key = auth.user.auth_key;
  const formData = new FormData();
  for (let value in values) {
    formData.append(value, values[value]);
  }
  const action = "afterlogin/usermodule/accessupdate";
  formData.append("auth_key", auth_key);
  formData.append("action", action);
  return axios.post(API_URL + action, formData, { headers: requestHeaders(auth, "multipart/form-data") });
};

const usermoduleApiController = {
  moduleview,
  accessview,
  update,
};
export default usermoduleApiController;
